import { receiveStatus } from "./receiveStatus";
import {StaffProfile} from "../infrastructure/auth";
import { PurchaseOrder } from "../common/PurchaseOrder";
import {ReceiveType} from "./receiveTypeMapping";
import {Receive} from "../common/Receive";
export interface ReceiveObj {
	purchaseOrderNumber: string;
	invoiceNumber: string;
	status: string;
	supplierName: string;
	receiveLineItems: any[];
	inventoryStatus: string;
}

export interface LineItem {
	barcode: string;
	lineTotalCostEx: number;
	lineTotalCostTax: number;
	lineTotalCostInc: number;
	unitCostInc: number;
	unitCostEx: number;
	unitCostTax: number;
	model: string;
	quantity: number;
	receivedQuantity: number;
	invoicedQuantity: number;
	sku: string;
	status: string;
}

export interface ShipToLocation {
	companyName: string;
	locationId: string;
}

export interface PurchaseOrderObj {
	shipToLocation: ShipToLocation;
	sourceId: string;
	lineItems: LineItem[];
	status: string;
	vendorName: string;
}

export interface Modal {
	isOpen: boolean;
	paragraphs: string[];
	primaryButtonName: string;
	secondaryButtonName?: string;
	onPrimaryButtonClick: () => void;
	onSecondaryButtonClick?: () => void;
	onExitClick: () => void;
	title: string;
}

export interface LoadingDialog {
	isOpen: boolean;
	message: string;
}

export interface CurrentScannedProduct {
	qty: number | null;
	productId: string;
}
export const emptyReceiveObj: ReceiveObj = {
	purchaseOrderNumber: "",
	invoiceNumber: "",
	status: "",
	supplierName: "",
	receiveLineItems: [],
	inventoryStatus: "Available",
};

export const emptyPurchaseOrderObj: PurchaseOrderObj = {
	shipToLocation: {
		companyName: "",
		locationId: "",
	},
	sourceId: "",
	lineItems: [
		{
			barcode: "",
			lineTotalCostEx: 0.0,
			lineTotalCostTax: 0.0,
			lineTotalCostInc: 0.0,
			unitCostInc: 0.0,
			unitCostEx: 0.0,
			unitCostTax: 0.0,
			model: "",
			quantity: 0,
			receivedQuantity: 0,
			invoicedQuantity: 0,
			sku: "",
			status: "",
		},
	],
	status: "",
	vendorName: "",
};

export const modalClosed: Modal = {
	isOpen: false,
	paragraphs: [""],
	primaryButtonName: "",
	onPrimaryButtonClick: () => {},
	onExitClick: () => {},
	title: "",
};

export const loadingDialogClosed: LoadingDialog = {
	isOpen: false,
	message: "",
};

export const emptyCurrentScannedProduct: CurrentScannedProduct = {
	qty: null,
	productId: "",
};

export function createReceive(purchaseOrder: PurchaseOrder, graphProfile: StaffProfile, receiveType: ReceiveType, receiveId: string) : Receive {
	return {
		id: receiveId,
		timestamp: new Date().toISOString(),
		createdTimestamp: new Date().toISOString(),
		receivedDate: "",
		supplierId: purchaseOrder.vendorId,
		supplierName: purchaseOrder.vendorName,
		purchaseOrderNumber: purchaseOrder.sourceId,
		invoiceNumber: "",
		invoiceDate: "",
		receiveLineItems: [],
		locationId: parseInt(purchaseOrder.shipToLocation.locationId, 10),
		totalInvoicedQuantity: 0,
		totalReceivedQuantity: 0,
		totalInvoicedFreightEx: 0,
		totalInvoicedFreightInc: 0,
		totalInvoicedFreightTax: 0,
		organisationId: "JBH",
		status: receiveStatus.open,
		isEdi: purchaseOrder.isEdi,
		createdById: graphProfile.staffId,
		createdBy: graphProfile.displayName,
		modifiedById: graphProfile.staffId,
		modifiedBy: graphProfile.displayName,
		receiveType,
		inventoryStatus: "",
		notes: "",
		receiver: "",
		receiverId: "",
		receiptAttemptCount: 0,
		statusHistory: [
			{
				id: "",
				timestamp: new Date().toISOString(),
				status: "",
				userId: "",
				userName: "",
			},
		],
		failureReason: null,
		asnId: "",
		isPartReceived: false,
		sourceId: "",
	};
}
